import React from 'react';

import { Theme, useMediaQuery } from '@mui/material';
import Image, { ImageProps } from 'next/image';

type Props = Omit<ImageProps, 'src' | 'alt'> & {
  src: {
    sm: string;
    md: string;
    lg: string;
  };
  alt: string;
};

/**
 * Wrapper on next/image that allows for multiple image URLs to make it simpler to swap out
 * img asset by dimension.
 *
 * Behavior for now supports just sm/md/lg options and swaps out based on breakpoint; we can
 * extend in the future if we need to.
 *
 * `alt` is required in props and destructured / added to the <Image/> component explicitly to
 * avoid type error as the type checker is not picking up automatically that it is on the props.
 *  */
const ImageDynamicSrc: React.FC<Props> = (props) => {
  const { src, alt, ...rest } = props;
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
  const isMed = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const imgSrc = isSmall ? src.sm : isMed ? src.md : src.lg;
  return <Image src={imgSrc} alt={alt} {...rest} />;
};

export default ImageDynamicSrc;
